import type { PropsWithChildren } from 'react';
import React from 'react';
import type { FormInputProps } from '@gov-nx/ui/types';
import type { HeaderLayoutProps } from '@gov-nx/ui/web';
import {
	FormSearch,
	FormWidthElementLayout,
	HeaderLayout,
} from '@gov-nx/ui/web';

type Props = PropsWithChildren<{
	filterParams?: HeaderLayoutProps['filterParams'];
	fields: {
		search: FormInputProps;
		button: {
			wcagLabel: string;
		};
	};
}>;

export const HeaderSearchBar = ({ children, filterParams, fields }: Props) => (
	<HeaderLayout
		filterParams={filterParams}
		className="flex justify-between gap-(--templates-margin-m)">
		<FormWidthElementLayout
			type="l"
			className="relative">
			<FormSearch
				input={fields.search}
				button={{
					'aria-label': fields.button.wcagLabel,
				}}
			/>
		</FormWidthElementLayout>
		{children}
	</HeaderLayout>
);
